import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fontSize",
  "use": "icon-fontSize-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fontSize\"><path d=\"M653.568 724.352l-366.72 0.32L216.32 893.888l158.656 0 0 57.088L64 950.976l0-57.088 55.424 0L495.232 73.088 528 73.088l386.304 820.8L960 893.888l0 57.088-280.96 0 0-57.088 60.544 0L653.568 724.352zM339.264 614.656l256.64-0.768L480 376.768 456.96 376.768 339.264 614.656z\" fill=\"#8A8F93\" p-id=\"5480\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol